export class DepartmentNavigationInformation {
  departmentsToClose: number[];
  selectedStructure: number;

  constructor() {
    this.departmentsToClose = [];
  }
}
